import HomepageActionTypes from 'app/homepage/ActionTypes';
import reducer from 'app/homepage/reducer';
import routes from 'app/homepage/routes';

export default {
  reducers: {
    homepage: reducer,
  },
  actionTypes: HomepageActionTypes,
  routes,
};
